import {
  SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_BEGIN,
  SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_SUCCESS,
  SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_FAILURE,
  SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getAllConfigType() {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:'/api/b/systemConfigType/list',
        }).then( data => {
            dispatch({
                type: SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAllConfigTypeError() {
  return {
    type: SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllConfigTypePending: true,
        getAllConfigTypeError: null,
      };

    case SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_SUCCESS:
      // The request is success
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
            items.push(item.id);
            byId[item.id] = item;
        });
      return {
        ...state,
        allConfigType:byId,
        allConfigList:items,
        getAllConfigTypePending: false,
        getAllConfigTypeError: null,
      };

    case SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllConfigTypePending: false,
        getAllConfigTypeError: action.data.error,
      };

    case SYSTEMCONFIG_GET_ALL_CONFIG_TYPE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllConfigTypeError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/getAllConfigType.js